import { BusyButton } from '@lucidhq/lucidium';
import { useFormikContext } from '@lucidhq/lucidium/components/FormV2';
import { ReactNode } from 'react';

export interface SubmitButtonProps {
  children: ReactNode;
  isLoading?: boolean;
  isDisabled?: boolean;
}

export const SubmitButton = ({
  children,
  isLoading,
  isDisabled,
}: SubmitButtonProps) => {
  const { isSubmitting } = useFormikContext();

  return (
    <BusyButton
      type="submit"
      isBusy={isSubmitting || isLoading}
      disabled={isDisabled}
    >
      {children}
    </BusyButton>
  );
};
